import axios from 'axios'
import env from '../env'
import { storeMobx } from 'restaurant'

export default class MoApi {
  static async placeTopup (params: any) {
    let Url: string = `${env.ORDER}/saveTopup`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  static async placeGoods (params: any) {
    const Url: string = `${env.ORDER}/saveGoods`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  static async placeGroupBuy (params: any) {
    const Url: string = `${env.MEMBER}/order/save`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  static async getOrderDetail (params: any) {
    let Url: string = `${env.ORDER}/getOrdersDetail`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  static async getOrdersListByStore (params: any) {
    const Url: string = `${env.ORDER}/query/getOrdersListByStore`
    const res: any = await axios.post(Url, params)
    return res.error ? res : res.result
  }

  static startPay (para: any) {
    let Url: string = `${env.ORDER}/startPay`
    return axios.post(Url, para)
  }

  static getBulkAvatars (memberIds: number[], channel?: 'wechatminiapp' | 'wechat') {
    let Url: string = `${env.MEMBER}/member/bulkAvatars`
    const params: {
      brandId: number;
      memberIds: number[];
      channel?: 'wechatminiapp' | 'wechat';
    } = {
      brandId: storeMobx.brand.brandId,
      memberIds
    }
    if (channel) {
      params.channel = channel
    }
    return axios.post(Url, params)
  }
}
